export const mediaUrl = (id: number) => CROSS_API_URL + `/medias/${id}`